module.exports = __webpack_public_path__ + "e29a0848471e494f9edd0649a9b1a2d4.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/160.png
// module id = 1755
// module chunks = 2